import './css/base.css'
import 'normalize.css'
import '../ele-theme/index.css'
import './css/el-overwrite.css'

import Vue from 'vue'
import router from './router'
import store from './vuex'
import ElementUI from 'element-ui'
import i18n from './i18n'

import App from './App'
import './config.js'

Vue.prototype.baseUrl = '/manage/v1/'

Vue.use(ElementUI)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



window.onstorage = function(e) {
  if ((e.key === 'pvsuser' && e.newValue !== e.oldValue) || !e.key) {
    window.location.reload()
  }
}



// WEBPACK FOOTER //
// ./src/main.js